<template>
    <modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `users/${inputs.id}` : `users`'>

                <!-- First Name Input -->
                <div class="form-group">
                    <label for="inputs_firstname">{{ $t('first_name') }}</label>
                    <app-input id="inputs_firstname" type="text" v-model="inputs.first_name" :placeholder="$t('first_name')"
                        :required="true" />
                </div>

                <!-- Last Name Input -->
                <div class="form-group">
                    <label for="inputs_lastname">{{ $t('last_name') }}</label>
                    <app-input id="inputs_lastname" type="text" v-model="inputs.last_name" :placeholder="$t('last_name')"
                        :required="true" />
                </div>

                <!-- Email Address Input -->
                <div class="form-group">
                    <label for="inputs_email">{{ $t('email') }}</label>
                    <app-input id="inputs_email" type="email" v-model="inputs.email" :placeholder="$t('email')"
                        :required="true" />
                </div>

                <!-- User Status Input -->
                <div class="form-group">
                    <label for="inputs_status">{{ $t('status') }}</label>
                    <app-input id="inputs_status" list-value-field="translated_name" type="select" :required="true"
                        v-model="inputs.status_id" :list="statusList" />
                </div>
                <!-- Role Select Input -->
                <div class="form-group" v-if="!this.selectedUrl">
                    <label for="role">{{ $t('role') }}</label>
                    <div class="d-flex align-items-center w-100">
                        <app-input class="w-100" id="role" v-model="inputs.role_id" :list="roleList" list-value-field="name"
                            :placeholder="$t('choose_a_role')" type="search-select" :required="true" />
                    </div>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
import { mapState } from 'vuex';
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';
import * as actions from '../../../Config/ApiUrl';


export default {
    name: "UserAddEditModal",
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: String,
    },
    data() {
        return {
            preloader: false,
            inputs: {},
            modalId: 'user-add-edit-Modal',
            modalTitle: `${this.$t('add')} ${this.$t('new')} ${this.$t('user')}`,
            statusList: [],
        }
    },
    computed: {
        ...mapState({
            roleList: state => state.notificationSettings.roles,
        }),
    },
    created() {
        this.getStatuses();
        this.$store.dispatch('getAllRoles');
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
    methods: {
        submit() {
            this.save(this.inputs);
            this.$hub.$emit('reload-' + this.tableId);
        },
        getStatuses() {
            let url = `${actions.GET_STATUSES}?type=user`;
            this.axiosGet(url).then(response => {
                this.statusList = response.data;
            });
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData(response) {
            this.inputs = response.data;
            this.preloader = false;
        },
    },
}
</script>
